import * as React from "react";
import { Link } from "react-router-dom";
import { DirectDebitDetailsSection } from "./DirectDebitDetailsSection";
import {Mandate} from "@ferry/journey-services";
import {InfoBanner, resourcesHelper} from "@ferry/portal-core";

interface IProps {
    policyNumber: string;
    interaction: any;
    haveActiveMandate: boolean;
    mandate?: Mandate;
    annualToMonthly?: boolean;
    hasRefundMandate?: boolean;
}

export class DirectDebitSection extends React.Component<IProps> {
    public render() {
        const { annualToMonthly, haveActiveMandate, hasRefundMandate, mandate, policyNumber } = this.props;
        const directDebitProcessLink = `/dashboard/${policyNumber}/paymentDetails/editDirectDebit/`;
        return (
            <div className="direct-debit-section">
                <div className="d-flex flex-row">
                    <div className="d-none d-md-flex flex-column">
                        <img
                            className="icon-panel mb-0"
                            src={`/${resourcesHelper.THEME_PATH}/img/direct-debit-icon.svg`}
                            alt="Debit icon"
                            aria-label="Debit icon"
                        />
                    </div>
                    <div className="d-flex flex-column justify-content-center w-100">
                        <div className="d-md-none d-flex align-i-center mb-3">
                            <img
                                className="icon-panel mb-0"
                                src={`/${resourcesHelper.THEME_PATH}/img/direct-debit-icon.svg`}
                                alt="Debit icon"
                                aria-label="Debit icon"
                            />
                            <h2 className="font-family-display font-weight-bold mb-0">Direct Debit details</h2>
                        </div>
                        <div className="d-flex flex-column">
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h2 className="font-family-display font-weight-bold d-md-block d-none mb-0">Direct Debit details</h2>
                                {annualToMonthly && (
                                    <div className="bubble-container">
                                        <div className="corner-bubble">Renewal only</div>
                                    </div>
                                )}
                            </div>
                            {hasRefundMandate && (
                                <InfoBanner wording={<>Heads up - these are the details we will use for any future refunds.</>}/>
                            )}
                            <DirectDebitDetailsSection
                                haveActiveMandate={haveActiveMandate}
                                mandate={mandate}
                                policyNumber={this.props.policyNumber}
                            />
                            <Link
                                to={{
                                    pathname: directDebitProcessLink,
                                }}
                                state={{ policyNumber: this.props.policyNumber }}
                                id="editDirectDebit">
                                <button className="direct-debit-button btn btn-blue-dashboard mb-0 mt-0">
                                    {haveActiveMandate ? "Edit Direct Debit" : "Set-up Direct Debit"}
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
